/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Notification } from '@app/notifications/notifications/notification.model';
import swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/notifications', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((notification: any) => {
          return new Notification().deserialize(notification);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(notification: Notification): Observable<any> {
    return this.http.put('v1/notifications/' + notification.id, notification);
  }

  readAllOfUser(userId: number | string): Promise<any> {
    return swal
      .fire({
        title: 'Are you sure?',
        //text: 'Your comment will be lost',
        showConfirmButton: true,
        showCancelButton: true,
        icon: 'warning',
        backdrop: true,
      } as SweetAlertOptions)
      .then((res) => {
        if (!res.isConfirmed) {
          return Promise.reject(res);
        }
        return this.http.post('v1/notifications/' + userId + '/read-all', {}).toPromise();
      });
  }
}
